<script>
/* eslint-disable */
import WorkoutTabs from "../components/pages/create-update-workout/Tabs.vue";
import ScriptModal from "../components/script-builder/Modal.vue";
import NotesModal from "../components/notes/NotesModal.vue";
import WarmupTabs from "../components/pages/create-update-warmup/Tabs.vue";
import StretchflowTabs from "../components/pages/create-update-stretch-flow/Tabs.vue";
import FileUpload from "../components/pages/create-update-workout/uploads/FileUpload.vue";
import ApprovalModal from "../components/pages/ApprovalModal.vue";
import FloatingButton from "../components/floating-button/FloatingButton.vue";

export default {
  name: "UpdateWorkout",
  data() {
    return {
      type: false,
    };
  },
  components: {
    ScriptModal,
    WorkoutTabs,
    NotesModal,
    WarmupTabs,
    FileUpload,
    StretchflowTabs,
    ApprovalModal,
    FloatingButton,
  },
  computed: {
    currentType() {
      const url = this.$route.path.split("/")[1];
      if (this.$route) {
        if (url == "update-warmup" || this.$route.path == "/create-warmup") {
          return "warmups";
        } else if (
          url == "update-stretch-flow" ||
          this.$route.path == "/create-stretch-flow"
        ) {
          return "stretchflows";
        }
      }
      return "workouts";
    },
  },
  created() {
    this.$store.dispatch(`${this.currentType}/getFieldOptions`);
    this.$store.dispatch(`workouts/getWarmupsOptions`);
    this.$store.dispatch(`workouts/getStretchFlowsOptions`);
  },
  async mounted() {
    this.$store.commit("commons/setPreloader", true);

    this.$store.commit("scripts/setActiveWorkout", this.$route.params.id);

    await this.$store.dispatch("scripts/getCircuits", this.$route.params.id);
    await this.$store.dispatch(
      `scripts/getAutoCueWithRests`,
      this.$route.params.id
    );
    await this.$store.dispatch(
      `scripts/getAutoCueWithRestsAndCircuitDetails`,
      this.$route.params.id
    );

    
    await this.$store
      .dispatch(`${this.currentType}/getActivity`, this.$route.params.id)
      .then((res) => {
        this.$store.commit("commons/setPreloader", false);
      });

    if (this.$route) {
      const url = this.$route.path.split("/")[1];
      if (url == "update-warmup" || this.$route.path == "/create-warmup") {
        this.type = "warmup-tabs";
      } else if (
        url == "update-workout" ||
        this.$route.path == "/create-workout"
      ) {
        this.type = "workout-tabs";
      } else if (
        url == "update-stretch-flow" ||
        this.$route.path == "/create-stretch-flow"
      ) {
        this.type = "stretchflow-tabs";
      }
    }
  },
};
</script>

<template>
  <div>
    <component v-bind:is="type"></component>
    <script-modal></script-modal>
    <notes-modal> </notes-modal>
    <file-upload></file-upload>
    <approval-modal> </approval-modal>
  </div>
</template>
